import * as Common from '@/tenantCatalog/common';

export class BillingItem extends Common.ObjectBase{
  constructor(){
    super('BillingItem');
    this.binders.tenant = new Common.ModelBinder(Common.Tenant);    
  }
  public get tenantId() :string{
    return this.tenant? this.tenant.id : '';
  } 
  public set tenantId(value:string) {}
  public tenant : Common.Tenant;
  public closingDate : Date;
  public description : string;
  public quantity : number = 0;
  public unitPrice : number = 0;
  public get amount() : number {    
    return this.quantity * this.unitPrice;
  }
  public set amount(value:number){

  }
  public batch : boolean = false;

}

export class BillingItemQuery extends Common.LoadQuery {
  constructor(){
    super('BillingItemQuery',BillingItem);
    this.sort = 'tenantId';    
  }
  public tenantId :string = '';
  public tenantName: string = '';
  public closingDate : Date = null;    
  public batch : boolean = null;    
}